import { createFileRoute } from '@tanstack/react-router'
import { FlowDashboardPage } from '@/components/inventory-flow/FlowDashboard'

// Kitchen flow Stage 3: the owner's flow dashboard (admin). Renders a "not
// switched on" note unless GET /settings carries kitchen_flow=true.
export const Route = createFileRoute('/admin/kitchen-flow')({
  component: FlowDashboardPage,
})
